import { parseTenantSlugFromHost } from '@aimsis/shared'

const DEFAULT_BASE_DOMAIN = 'aimsis.com'

function baseDomain(): string {
  return import.meta.env.VITE_TENANT_BASE_DOMAIN?.trim() || DEFAULT_BASE_DOMAIN
}

/**
 * Resolve CBT tenant slug from the current browser location.
 *
 * Prod: `{cbt_subdomain}.aimsis.com` — one build serves every school, so the
 * hostname decides the tenant.
 *
 * `VITE_TENANT_SLUG` is a fallback for hosts that name no tenant: localhost,
 * the e2e server, and fixed-tenant deployments whose host is not a flat
 * subdomain of the base domain (`demo.cbt.aimsis.com`). It must never
 * outrank a hostname that does name a tenant, or a bundle built with a demo
 * override would send that demo slug from every school's domain.
 */
export function resolveTenantSlug(): string | null {
  const hostname = window.location.hostname.toLowerCase()
  const fromHost = parseTenantSlugFromHost(hostname, baseDomain())
  if (fromHost) return fromHost

  return import.meta.env.VITE_TENANT_SLUG?.trim() || null
}

export function isProdLikeTenantHost(): boolean {
  const hostname = window.location.hostname.toLowerCase()
  if (hostname === 'localhost' || hostname === '127.0.0.1') return false
  return hostname.endsWith(`.${baseDomain()}`)
}

export function tenantBaseDomain(): string {
  return baseDomain()
}
